import { render, staticRenderFns } from "./popupAnotacaoWrapper.vue?vue&type=template&id=750b9a8f&scoped=true"
import script from "./popupAnotacaoWrapper.vue?vue&type=script&lang=js"
export * from "./popupAnotacaoWrapper.vue?vue&type=script&lang=js"
import style0 from "./popupAnotacaoWrapper.vue?vue&type=style&index=0&id=750b9a8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b9a8f",
  null
  
)

export default component.exports